import { useState } from 'react';

const useCustomHook = () => {
  const [loading, setLoading] = useState(false);
  const [productSearchText, setProductSearchText] = useState('');
  const [allProductAllow, setAllProductAllow] = useState(true);
  const [businessSearchText, setBusinessSearchText] = useState();
  const [addProductIsOpen, setAddProductIsOpen] = useState(false);
  const [allowedProducts, setAllowedProducts] = useState([]);
  const [size, setSize] = useState(10);
  const [page, setPage] = useState(0);

  return {
    loading,
    setLoading,
    productSearchText,
    setProductSearchText,
    allProductAllow,
    setAllProductAllow,
    businessSearchText,
    setBusinessSearchText,
    page, setPage,
    addProductIsOpen,
    setAddProductIsOpen,
    allowedProducts,
    setAllowedProducts,
    size,
    setSize,
  };
};

export default useCustomHook;
